import Vue from 'vue'

const state = {
  definitions: null
}

const mutations = {
  SET_INVENTORY_DEFS (state, definitions) {
    state.definitions = definitions
  }
}

const actions = {
  fetchAll: ({commit}) => {
    return Vue.prototype.$axios.get('inventory-definitions')
      .then(response => {
        commit('SET_INVENTORY_DEFS', response.data)
      })
  }
}

const getters = {
  fetchById: state => id => {
    return state.definitions[id]
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
